<template>
    <small v-if="slug.split('-').slice(-1).pop() > 1">({{ slug.split('-').slice(-1).pop() }})</small>
</template>

<script>
export default {
    name: 'AppVehicleNo',
    props: {
        slug: String
    }
};
</script>
